export const hotTopics = [
  "某男星连夜撤销婚姻",
  "千万网红偷税漏税",
  "综艺投票系统黑幕",
  "导演潜规则录音曝光",
  "照骗产业链揭秘",
  "蒲公英事件真相",
  "选角后台关系图",
  "直播带货三无产品",
  "海外隐秘财产",
  "最离谱塌房理由",
  "恋爱综艺劈腿",
  "尴尬同框大赛",
];